import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {Alert, Col, Row} from 'react-bootstrap';
import PublicLayout from './PublicLayout';
import {usePublicTiersPayant} from '../../hooks/api/publicTiersPayant';
import ActionRequiredCard from './components/ActionRequiredCard';
import AlertedBanner from './components/AlertedBanner';
import DossierInfoCard from './components/DossierInfoCard';
import DocumentsCard from './components/DocumentsCard';
import TimelineCard from './components/TimelineCard';
import ActionFormCard from './components/ActionFormCard';
import CommentCard from './components/CommentCard';
import HelpCard from './components/HelpCard';

const PublicTiersPayantPage = () => {
    const {token} = useParams();
    const {data, loading, error, submit, alert} = usePublicTiersPayant(token);
    const [submitting, setSubmitting] = useState(false);
    const [submitResult, setSubmitResult] = useState(null);

    if (loading) {
        return <PublicLayout><p>Chargement…</p></PublicLayout>;
    }
    if (error?.code === 'not_found') {
        return <PublicLayout><Alert variant="danger">Lien invalide ou expiré.</Alert></PublicLayout>;
    }
    if (error?.code === 'closed') {
        return <PublicLayout><Alert variant="info">Ce dossier a déjà été traité. Le lien n&apos;est plus actif.</Alert></PublicLayout>;
    }
    if (error || !data) {
        return <PublicLayout><Alert variant="danger">Une erreur est survenue. Réessayez plus tard.</Alert></PublicLayout>;
    }

    const {dossier, customer, healthInsurance, action, timeline, documents} = data;
    const isAlerted = !!action?.isAlerted;

    const handleSubmit = async (payload) => {
        setSubmitting(true);
        const result = await submit(payload);
        setSubmitting(false);
        setSubmitResult(result);
        return result;
    };

    return (
        <PublicLayout title={customer?.name}>
            <h2>Dossier de remboursement</h2>

            {isAlerted
                ? <AlertedBanner />
                : <ActionRequiredCard mailInformation={dossier.mailInformation} actionType={action?.type} />}

            <Row>
                <Col lg={8}>
                    <DossierInfoCard dossier={dossier} customer={customer} healthInsurance={healthInsurance} />
                    <DocumentsCard token={token} documents={documents} />
                    <TimelineCard timeline={timeline} />
                    {!isAlerted && (
                        <ActionFormCard
                            action={action}
                            onSubmit={handleSubmit}
                            submitting={submitting}
                            submitResult={submitResult}
                        />
                    )}
                </Col>
                <Col lg={4}>
                    <HelpCard />
                    {!isAlerted && (
                        <CommentCard isAlerted={isAlerted} onAlert={alert} />
                    )}
                </Col>
            </Row>
        </PublicLayout>
    );
};

export default PublicTiersPayantPage;
